import { render, staticRenderFns } from "./DebugButton.vue?vue&type=template&id=5a3800ea&scoped=true&"
import script from "./DebugButton.vue?vue&type=script&lang=js&"
export * from "./DebugButton.vue?vue&type=script&lang=js&"
import style0 from "./DebugButton.vue?vue&type=style&index=0&id=5a3800ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3800ea",
  null
  
)

export default component.exports